import React,{Component} from "react";
import { FaRegEdit } from "react-icons/fa";
import axios from "axios";

class DescribeCourse extends Component{
    state ={
        course: [],
        isEditing: false,
        updatedDescriptionText: '',
    }
    inputRef = React.createRef();
    componentDidMount() {
        this.fetchCourses();
    }
    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
        }
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            const course_id = this.props.course_id
            const courseId = parseInt(course_id, 10);
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/courses/" + courseId, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
              this.setState({ course: response.data });
              console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };



     // starting her for the header of the course


     handleEditClick = () => {
        this.setState({
            isEditing: true,
            updatedDescriptionText: this.state.course.description // Initialize updatedHeadingText with current headingText 
        }, () => {
            if (this.inputRef.current) {
                this.inputRef.current.focus();
            }
        });
    };

    handleInputChange = (event) => {
        this.setState({ updatedDescriptionText: event.target.value });
    };

    handleBlur = () => {
        this.submitChanges();
    };

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.submitChanges();
        }
    };




    //   this is the sending the new header to the api 


    submitChanges = () => {
        const accessToken = localStorage.getItem("accessToken");
        const { updatedDescriptionText } = this.state;
        const course_id = this.props.course_id
        const courseId = parseInt(course_id, 10);
        // Send the updatedHeadingText to your API here
        fetch(`https://api.geoinfoacademy.com/api/tutor/courses/${courseId}/`, {
            method: 'PATCH', // Assuming you're updating the existing heading
            headers: { 
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json' 
         },
            body: JSON.stringify({ description: updatedDescriptionText })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Update headingText with the successfully updated value
                this.fetchCourses();  // <--- This is the crucial change

            this.setState({ 
                isEditing: false, // Close the input field
                updatedDescriptionText: '' // Clear the input field
             });
            console.log('Course updated successfully:', data);
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });

        this.setState({ isEditing: false });
    };




    render(){
        const course =  this.state.course
        return(
            <section className="course_description">
                        <h3>Course description <button className=" add" onClick={this.handleEditClick}>Edit</button></h3>
                        {this.state.isEditing ? (
                            <div>
                            <textarea
                                type="text"
                                ref={this.inputRef}
                                value={this.state.updatedDescriptionText} // Use updatedHeadingText for input
                                onChange={this.handleInputChange}
                                onBlur={this.handleBlur}
                                onKeyDown={this.handleKeyDown}
                            />
                            <button className="add" onClick={this.handleKeyDown}>Submit</button>
                            </div>
                        ) : (
                            <p><button className="edit" onClick={this.handleEditClick}><FaRegEdit /></button>{course.description}
                             </p>
                        )}

                       
                    </section>
        )
    }
}

export default DescribeCourse